// extracted by mini-css-extract-plugin
export var footerContentWrapper = "footer-module--footer-content-wrapper--h+ny+";
export var footerContentRight = "footer-module--footer-content-right--epcol";
export var footerContentLeft = "footer-module--footer-content-left--W9yM2";
export var footerContactInfo = "footer-module--footer-contact-info--7MSH-";
export var formTitle = "footer-module--form-title--oFIsm";
export var formSubtitle = "footer-module--form-subtitle--YPbfH";
export var googleMap = "footer-module--google-map--ObqIh";
export var colophon = "footer-module--colophon--s2HYu";